export const SITE = process.env.GATSBY_CRAFT_SITE_HANDLE || "default";

const constants = {
  SITE,
};

export default constants;
